// extracted by mini-css-extract-plugin
module.exports = {"external":"widget-space--external--GphXt","externalIcon":"widget-space--externalIcon--XgMMb"};